"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configureProductDucks = void 0;
const config = {
  getToState: () => {
    throw new Error('getToState must be configured.');
  },
  defaultTypes: [],
  filterTypes: [],
  orderTypes: [],
  customerProductMarkets: [],
  onLoadRegistry: () => () => {},
  onLoadProducts: () => () => {},
  onBeforeSelectProduct: () => () => true,
  onAfterSelectProduct: () => () => {}
};
const configureProductDucks = customConfig => {
  Object.assign(config, customConfig);
};
exports.configureProductDucks = configureProductDucks;
var _default = config;
exports.default = _default;